export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.efa76f83.ttf";